export const userProfilePath = 'hsn/user/profiles';
export const geolocationsPath = 'hsn/geolocations';
export const companiesPath = 'hsn/companies';
export const userPreferencesPath = 'userpreferences/v1';
export const MAX_AVATAR_FILE_SIZE_MB = 3;
export const emptySearchResponse = {
  hasMore: false,
  offset: 0,
  total: 0,
  results: []
};
export let Goal;

(function (Goal) {
  Goal["Jobseeking"] = "LOOKING_FOR_WORK";
  Goal["Hiring"] = "HIRING";
  Goal["Upskilling"] = "UPSKILLING";
  Goal["Troubleshooting"] = "TROUBLESHOOTING";
  Goal["Connect"] = "CONNECT";
})(Goal || (Goal = {}));

export let OrderBy;

(function (OrderBy) {
  OrderBy["Recent"] = "recent";
  OrderBy["Newest"] = "newest";
  OrderBy["NameAscending"] = "nameAsc";
  OrderBy["NameDescending"] = "nameDesc";
})(OrderBy || (OrderBy = {}));

export const OrderBySortParameters = {
  [OrderBy.Recent]: ['CREDENTIAL_MUTATED_AT', 'DESC'],
  [OrderBy.Newest]: ['CREATED_AT', 'DESC'],
  [OrderBy.NameAscending]: ['DISPLAY_NAME', 'ASC'],
  [OrderBy.NameDescending]: ['DISPLAY_NAME', 'DESC']
};
export let Product;

(function (Product) {
  Product["Marketing"] = "MARKETING_HUB";
  Product["Sales"] = "SALES_HUB";
  Product["Operations"] = "OPS_HUB";
  Product["Service"] = "SERVICE_HUB";
  Product["CMS"] = "CMS_HUB";
})(Product || (Product = {}));

export let FilterQuery;

(function (FilterQuery) {
  FilterQuery["goals"] = "goals";
  FilterQuery["products"] = "products";
  FilterQuery["search"] = "search";
  FilterQuery["location"] = "location";
  FilterQuery["industry"] = "industry";
  FilterQuery["orderBy"] = "orderBy";
  FilterQuery["company"] = "company";
})(FilterQuery || (FilterQuery = {}));

export const SocialMediaSlugs = {
  linkedin: 'linkedin.com/in/',
  twitter: 'twitter.com/',
  github: 'github.com/',
  meetings: 'meetings.hubspot.com/'
};